<template>
	<div class="category">
		<el-row>
			<el-col style="width: 140px; margin-left: 40px;">
				<el-input v-model="query.uid" placeholder="请输入用户UID"></el-input>
			</el-col>
			<el-col style="width: 140px; margin-left: 40px;">
				<el-input v-model="query.name" placeholder="请输入用户昵称"></el-input>
			</el-col>
			<el-col style="width: 220px; margin-right: 20px;">
				<el-date-picker
					v-model="query.start_time"
					type="datetime"
					value-format="yyyy-MM-dd HH:mm:ss"
					placeholder="选择起始时间"
				>
				</el-date-picker>
			</el-col>
			<el-col style="width: 220px; margin-right: 20px;">
				<el-date-picker
					v-model="query.end_time"
					type="datetime"
					value-format="yyyy-MM-dd HH:mm:ss"
					placeholder="选择起始时间"
				>
				</el-date-picker>
			</el-col>
			<el-col style="width: 50px; margin-left: 120px;">
				<el-button class="pull-right" type="primary" @click="handleSearch">搜索</el-button>
			</el-col>
		</el-row>
		<div>
			<el-table :data="dataList" v-loading="loading">
				<el-table-column prop="pid" label="上级用户ID"></el-table-column>
				<el-table-column prop="user_id" label="用户ID"></el-table-column>
				<el-table-column prop="name" label="用户昵称"></el-table-column>
				<el-table-column prop="type" label="用户属性"></el-table-column>
				<el-table-column prop="ratio" label="主播分成"></el-table-column>
				<el-table-column prop="settlement_amount" label="主播推广金额"></el-table-column>
				<el-table-column prop="settlement_into_amount" label="主播分成金额"></el-table-column>
			</el-table>
			<el-pagination
				background
				:total="dataMeta ? dataMeta.total : 0"
				:current-page="dataMeta ? dataMeta.current_page : 1"
				:page-size="dataMeta ? dataMeta.per_page : 15"
				@current-change="handlePageChange"
			></el-pagination>
		</div>
	</div>
</template>

<script>
import { getApiData } from '../../http'
export default {
	data() {
		return {
			loading: false,
			dataList: undefined,
			dataMeta: {},
			query: {
				page: 1,
				uid: undefined,
				name: undefined,
				start_time: undefined,
				end_time: undefined
			}
		}
	},
	methods: {
		getData() {
			this.loading = true
			getApiData(`user_anchors`, { page: this.query.page, uid: this.query.uid, name: this.query.name, start_time: this.query.start_time, end_time: this.query.end_time })
				.then(res => {
					this.dataList = res.data
					this.dataMeta = {
						current_page: res.current_page,
						per_page: res.per_page,
						total: res.total
					}
				})
				.finally(() => {
					this.loading = false
				})
		},
		handleSearch() {
			this.query.page = 1
			this.getData()
		},
		handlePageChange(page) {
			this.query.page = page
			this.getData()
		}
	},
	created() {
		this.getData()
	}
}
</script>

<style lang="less">
.table-image {
	max-height: 100px;
	max-width: 100px;
}

.avatar-uploader {
	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 128px;
		height: 128px;
		line-height: 128px;
		text-align: center;
	}

	.el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.el-upload:hover {
		border-color: #409eff;
	}

	.avatar {
		width: 128px;
		height: 128px;
		display: block;
	}
}

/*1.显示滚动条：当内容超出容器的时候，可以拖动：*/
.el-drawer__body {
	overflow: auto;
	/* overflow-x: auto; */
}

/*2.隐藏滚动条，太丑了*/
.el-drawer__container ::-webkit-scrollbar {
	display: none;
}


.abow_dialog {
	display: flex;
	justify-content: center;
	align-items: Center;
	overflow: hidden;

	.el-dialog {
		margin: 0 auto !important;
		height: 90%;
		overflow: hidden;

		.el-dialog__body {
			position: absolute;
			left: 0;
			top: 54px;
			bottom: 0;
			right: 0;
			padding: 0;
			z-index: 1;
			overflow: hidden;
			overflow-y: auto;
		}
	}
}
</style>
